<template>
    <div class="online" v-loading="loading">
        <div class="online_box">
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > 法律咨询 >在线咨询
            </div>
            <div class="bom_box_flex">
                <div class="lefts_box">
                    <!-- <div class="item_flex">
                        <div class="imgs">
                            <img src="@/assets/img/index/legal/bg1.png" alt="">
                        </div>
                        <div class="info_box">
                            <div class="info_top">
                                <div class="titles">
                                    客服咨询
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="consts">
                                    无论是初成立不久的初创型企业、进步中的成长型企业还是稳定运转的发展型企业，法律顾问在企业中都是不可缺无
                                    论是初成立不久的初创型企业、进步中的成长型企业还无论是初成立不久的初创型企业、进步中的成长型企业还是稳定运转的发展型企业，法律顾问在企业中都是不可缺无
                                    论是初成立不久的初创型企业、进步中的成长型企业还
                                </div>
                            </div>
                            <div class="info_bom">
                                <div class="price_btns_flex">
                                    <div class="price_text">免费</div>
                                    <div class="btns" @click="handle_path(item,index)">立即咨询</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="item_flex" v-for="(item,index) in lists" :key="index">
                        <div class="imgs">
                            <!-- {{ item }} -->
                            <!-- <img src="@/assets/img/index/legal/bg1.png" alt=""> -->
                            <img :src="item.thumb" alt="">
                        </div>
                        <div class="info_box">
                            <div class="info_top">
                                <div class="titles ">
                                    {{ item.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="consts">
                                  {{ item.desc }}
                                </div>
                            </div>
                            <div class="info_bom">
                                <div class="price_btns_flex">
                                    <div class="price_text">{{ item.price?(item.price):'免费' }} </div>
                                    <div class="btns" @click="handle_path(item,index)">立即咨询</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rights_box">
                    <div class="r_top">
                        <!-- <img src="@/assets/img/index/legal/r_top_bg.png" alt="" class="imgs"> -->
                        <div class="titles">律师在线解答</div>
                        <div class="text1">平均每5-10分钟获得律师快速解答</div>
                        <div class="nums">123123123</div>
                        <div class="text2">位用户已咨询</div>
                        <div class="btns_box">
                            <div class="btns" @click="$router.push('/lawyer_list')">快速咨询</div>
                        </div>
                    </div>
                    <div class="r_bom">
                        <div class="banner_title">推荐律师</div>

                        <div class="change_box">
                            <div class="change_item" :class="{'change_item_ac':banner_ac==index}" v-for="(item,index) in $store.state.vuex_lawyers" :key="index"></div>
                        </div>
                        <el-carousel :autoplay="true" :indicator-position="'none'" @change="change_banner"> 
                            <el-carousel-item v-for="(item,index) in $store.state.vuex_lawyers" :key="index">
                                <div class="banner_box">
                                    <div class="borders_box">
                                        <div class="borders1"></div>
                                        <div class="borders2">
                                            <!-- <img src="../../assets/img/index/legal/user_img.png" alt=""> -->
                                            <img :src="item.business_img" alt="">

                                        </div>
                                        <div class="tage_box" v-if="item.elite==1">
                                            <div class="tages">金牌律师</div>
                                        </div>
                                    </div>
                                    <div class="ls_name">{{item.name}}律师</div>
                                    <div class="ls_texts">{{minx_get_causeIds(item.causeIds)}}</div>
                                    <div class="btns_flex">
                                        <div class="btns"  @click="$router.push('/lawyer_detial?id='+item.id)">
                                            <img src="../../assets/img/index/legal/icons1.png" alt="">

                                            快速咨询
                                        </div>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
        <agreement ref="agreement"  @handle_end="handle_end"></agreement>
        <online_check ref="online_check"  @handle_end="handle_end"></online_check>

    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import online_check from '@/components/legal_advice/online_check.vue'//提交成功



export default {
    components: {
        online_check
    },
    name: "homes",
    data() {
        return {
            loading: false,
            yy_list:[1,2,3],//预约列表
            banner_ac:0,
            banner_list:[1,2,3],
            lists:[],
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_list()
    },
    mounted(){
        // 默认打开
        // this.$refs.agreement.handle_open()

    },
    methods: {
        get_list(){
            this.loading=true
            this.$api("servePros", {
				type:3,
                page:1,
                limit:10000,
			}, "get").then((res) => {
                this.loading = false
                console.log('其它立即咨询',res)
                if (res.code == 1) {
                    this.lists=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },
        change_banner(e){
            // console.log('却换触发',e)
            this.banner_ac=e
        },
        handle_path(item,index){
            if(index==0){
                //  //上班
                //  this.$router.push({
                //     path:'/online_work'
                // })

                //下班
                this.$router.push({
                    path:'/online_quitting'
                })
            }else{
                this.$refs.online_check.handle_open(item,2,1)
            }
        },
        handle_end(){
            console.log('隐私回调')
        },

    },

}
</script>
<style scoped lang="less">
.online {
    width: 100%;
    // height: 900px;
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .online_box{
        width: 1440px;
        height: 100%;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .bom_box_flex{
            display: flex;
            // align-items: center;
            // align-content: space-between;
            justify-content: space-between;
            .lefts_box{
                width: 1000px;
                // height: 778px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                // padding: 32px;
                padding: 0 32px;
                .item_flex{
                    display: flex;
                    // align-items: center;
                    // justify-content: space-between;
                    border-bottom: 1px solid #EEEEEE ;
                    padding: 32px 0;
                    .imgs{
                        width: 184px;
                        height: 160px;
                        flex-shrink: 0;
                        img{
                            width: 184px;
                            height: 160px;
                        }
                    }
                    .info_box{
                        padding-left:28px;
                        flex: 1;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: space-between;
                        .info_top{
                            width: 100%;
                            .titles{
                                display: flex;
                                align-items: center;
                                
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 18px;
                                color: #333333;
                                img{
                                    margin-left: 10px;
                                    width: 14px;
                                    height: 18px;
                                }
                            }
                            .consts{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:2;
                                -webkit-box-orient: vertical;
                                margin-top: 14px;
                            }
                        }
                        .info_bom{
                            width: 100%;
                            .price_btns_flex{
                                width: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .price_text{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 28px;
                                    color: #FD4C5C;

                                }
                                .btns{
                                    width: 134px;
                                    height: 36px;
                                    background: #377CFD;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    text-align: center;
                                    line-height: 36px;
                                    cursor: pointer;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                }
                            }
                        }
                   
                    }
                }
            }
            .rights_box{
                width: 420px;
                min-height: 100px;
                // background-color: red;
                .r_top{
                    width: 420px;
                    height: 300px;
                    position: relative;
                    padding: 32px 36px;
                    // background-image: url("@/assets/img/index/legal/r_top_bg.png" );
                    background-image: url('../../assets/img/index/legal/r_top_bg.png');
                    background-size: 100%;
                    // .imgs{
                    //     width: 420px;
                    //     height: 300px;
                    //     position: absolute;
                    //     left: 0;
                    //     top: 0;
                    // }
                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #333333;

                    }
                    .text1{
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .nums{
                        padding-top: 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #377CFD;

                    }
                    .text2{
                      
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .btns_box{
                        padding-top: 40px;
                        .btns{
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                        }
                    }
                }
                .r_bom{
                    width: 420px;
                    height: 460px;
                    // background: red;
                    margin-top: 24px;
                    position: relative;
                    .banner_title{
                        position: absolute;
                        top: 24px;
                        left: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;           
                        font-weight: bold;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                    .change_box{
                        position: absolute;
                        top: 32px;
                        right: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;
                        .change_item{
                            width: 6px;
                            height: 6px;
                            background: #F2F2F5;
                            border-radius: 50%;
                            margin-left: 6px;
                        }
                        .change_item_ac{
                            background: #377CFD;
                        }
                    }
                    /deep/.el-carousel{
                        width: 100%;
                        height: 100%;
                        .el-carousel__container{
                            width: 100%;
                            height: 100%;
                            .banner_box{
                                width: 100%;
                                height: 100%;
                                background-image: url('../../assets/img/index/legal/banner_bg.png');
                                background-size: 100%;
                                padding-top: 88px;
                                .borders_box{
                                    width: 160px;
                                    height: 160px;
                                    margin: auto;
                                    border-radius: 50%;
                                    // margin-top: 88px; 
                                    // background: #FFFFFF;
                                    // opacity: 0.2;
                                    position: relative;
                                    .borders1{
                                        width: 160px;
                                        height: 160px;
                                        background: #FFFFFF;
                                        opacity: 0.2;
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        z-index: 1;
                                        border-radius: 50%;

                                    }
                                    .borders2{
                                        width: 132px;
                                        height: 132px;
                                        background: #C4C4C4;
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        z-index: 2;
                                        border-radius: 50%;

                                        transform: translate(-50%,-50%);
                                        img{
                                            width: 132px;
                                            height: 132px;
                                            border-radius: 50%;

                                        }
                                    }
                                    .tage_box{
                                        width: 100%;
                                        position: absolute;
                                        z-index: 3;
                                        bottom: -4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        .tages{
                                            cursor: pointer;
                                            width: 104px;
                                            height: 32px;
                                            background: linear-gradient( 180deg, #FAECC6 0%, #F2CF85 100%);
                                            border-radius: 16px 16px 16px 16px;
                                            border: 1px solid #876052;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 14px;
                                            color: #6C3E2D;
                                            text-align: center;
                                            line-height: 32px;
                                        }
                                    }
                                    
                                }
                                .ls_name{
                                    padding-top: 28px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 24px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }
                                .ls_texts{
                                    padding-top: 14px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }   
                                .btns_flex{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding-top: 40px;
                                    .btns{
                                        width: 180px;
                                        height: 40px;
                                        background: #377CFD;
                                        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                                        border-radius: 4px 4px 4px 4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        line-height: 40px;
                                        text-align: center;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #FFFFFF;
                                        cursor: pointer;
                                        img{
                                            width: 14px;
                                            height: 14px;
                                            margin-right: 10px;
                                        }
                                    }
                                }
                            }
                        }
                        .el-carousel__indicators{
                            //  display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>